import React, { useState, useEffect }  from 'react';
import Grid from '@material-ui/core/Grid';
import AlertBox from '../../../../components/ShareComponents/AlertBox';
import InteractiveTool from '../../../../components/GraduateInteractiveTool';
import '../graduate.scss';
import { getInteractiveTools } from '../../../../services/ParameterService';
import { IGeneralParameter } from '../../../../interfaces/IGeneralParameter';


const GraduateInteractiveToolsView: React.FC = () => {

    const [interactiveTools, setInteractiveTools] = useState<Array<IGeneralParameter>>([]);

    useEffect(()=>{  

            const getInitialData = async()=>{

                window.scrollTo(0, 0);

                // data interactive tools
                const datainteractiveTools:any = await getInteractiveTools();
                setInteractiveTools(datainteractiveTools);

            }

            getInitialData();
            
        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[])

    return (
    <>
        <Grid container className="main-container">
                
                <Grid container item xs={12}>
                    <AlertBox
                        title="Información"
                        alert="info"
                        variantType="outlined"
                    >
                        {
                            <span className="alert-simple-text">
                                En esta sección, los egresados podrán acceder a herramientas interactivas diseñadas para optimizar su experiencia y facilitar diversas gestiones dentro del sistema.
                            </span>
                        }
                    </AlertBox>
                    {interactiveTools && interactiveTools.length>0 &&
                        interactiveTools.map((tool: IGeneralParameter) => (
                            <InteractiveTool
                                item = {tool.parameter_code}
                                title = {tool.name}
                                description = {tool.description}
                                link = {tool.short_description}
                            />
                        ))
                    }
                </Grid>

        </Grid>
    </>
    )
}

export default GraduateInteractiveToolsView
